import { DeleteOutlined, SaveOutlined, EditOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Table, Tabs, Form, Select, DatePicker, Space, Row, Col, Upload, UploadProps, UploadFile } from 'antd';
import { currencyFormat, dateCommon, formatVND, validateMessages } from '../../helpers/common';
import Column from 'antd/es/table/Column';
import { BacLuongResponse, QDBLRequest } from '../../models/hopdong/HopDong';
import { useEffect, useState } from 'react';
import ModalTextForm from '../../components/modal/ModalTextForm';
import { DataSelectBox } from '../../models/selectbox';
import Input from 'antd/es/input/Input';
import { convertDataSelectBox, convertDataSelectBoxHeSoLuong, layDanhMucChucVu, layDanhMucHeSoLuong } from '../../services/danhmuc';
import { luuQuyetDinhBacLuong, xoaQuyetDinhBacLuong } from '../../services/hopdong';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import DonViSelectTree from '../utils/DonViSelectTree';
import { HeSoLuong } from '@app/models/danhmuc/DanhMuc';
import NhomNhanSuSelectBox from '../utils/NhomNhanSuSelectBox';
import { urlAdmin } from '../../constants';
import { TaiLieu } from '../../models/nhanvien/TaiLieu';

const QuyetDinhBatLuongBox = ({ idHopDong, listData, select, defaultSelect, isThemMoi, onSubmit, onRowSelected }: { idHopDong: number, listData?: Array<BacLuongResponse>, select?: boolean, defaultSelect?: BacLuongResponse, isThemMoi?: boolean, onSubmit: () => void, onRowSelected?: (e: any) => void }) => {
    const [loading, setLoading] = useState(false);
    const [showModalLuong, setShowModalLuong] = useState<boolean>(false);
    const [idXoaQDBL, setIdXoaQDBL] = useState<number>(0);
    const [optionHeSoLuong, setOptionHeSoLuong] = useState<Array<DataSelectBox>>([]);
    const [dsHeSoLuong, setDSHeSoLuong] = useState<HeSoLuong[]>([]);
    const [optionChucVu, setOptionChucVu] = useState<Array<DataSelectBox>>([]);
    const [idsTaiLieuQDBLXoa, setIdsTaiLieuQDBLXoa] = useState<Array<number>>([]);
    const [form] = Form.useForm();
    const [bacLuongSelected, setBacLuongSelected] = useState<BacLuongResponse | undefined>(undefined);

    var fileHienTai: any = (defaultSelect?.dsTaiLieu || []).map((item: TaiLieu) => {
        return {
            uid: item.idTaiLieu + "tailieu",
            name: item.tenTep,
            status: 'done',
            url: urlAdmin + item.duongDan.replace(/\\/g, "/"),
            //url: item.duongDan.replace("View\\public", urlAdmin).replace(/\\/g, "/"),
        };
    });    
    const [fileList, setFileList] = useState<UploadFile[]>(fileHienTai);

    const handleChangeCurrency = (e: any) => {
        e.preventDefault();
        const { value } = e.target;
        const parsedValue = value.replace(/[^0-9]/g, '').trim().replace(/^0+/, '');
        var format = currencyFormat.formatMoney(parsedValue);
        form.setFieldsValue({
            mucLuongThucNhan: parsedValue,
            mucLuongThucNhanStr: format
        });
    };

    const onChangeHeSoLuong = (e: number) => {
        var heso = dsHeSoLuong.find(x => x.id == e);
        var format = currencyFormat.formatMoney(heso?.mucLuong);
        form.setFieldsValue({
            mucLuongThucNhan: heso?.mucLuong,
            mucLuongThucNhanStr: format
        });
    }

    const props: UploadProps = {
        onRemove: (file) => {
            if (file.uid.includes("tailieu")) {
                var id = parseInt(file.uid.split("tailieu")[0]);
                setIdsTaiLieuQDBLXoa([...idsTaiLieuQDBLXoa, id]);
            }
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
        },
        beforeUpload: (file) => {
            const maxSize = 20000000; // 20 MB
            if (file.size > maxSize) {
                alert('Tệp tin đính kèm không được vượt quá 20MB');
            } else {
                setFileList([...fileList, file]);
            }
            return false;
        },
        fileList,
    };

    const loadDataSelectBoxs = async () => {
        try {
            setLoading(true);

            var chucVu = await layDanhMucChucVu();                        
            setOptionChucVu(convertDataSelectBox(chucVu));
            setLoading(false);
        }
        catch (err: any) {
            setLoading(false);
        }
    }

    const loadDataHeSoLuong = async (id: number) => {
        try {
            setLoading(true);
            var heSoLuong = await layDanhMucHeSoLuong(id);
            setOptionHeSoLuong(convertDataSelectBoxHeSoLuong(heSoLuong));
            setDSHeSoLuong(heSoLuong);
            setLoading(false);
        }
        catch (err: any) {
            setLoading(false);
        }
    }

    const onFinish = async (values: any) => {
        try {
            setLoading(true);
            var ngayKyQD = dateCommon.formatDate(values.ngayKyQD?.$d);
            var ngayBatDau = dateCommon.formatDate(values.ngayBatDau?.$d);
            var ngayKetThuc = dateCommon.formatDate(values.ngayKetThuc?.$d);
            var request: QDBLRequest = {
                files: fileList,
                id: values.id || null,
                idChucVu: values.idChucVu,
                idHopDong: values.idHopDong,
                idDonVi: values.idDonVi,
                idHeSoLuong: values.idHeSoLuong,
                idNhomNhanSu: values.idNhomNhanSu,
                mucLuongThucNhan: values.mucLuongThucNhan,
                ngayBatDau: ngayBatDau,
                ngayKetThuc: ngayKetThuc,
                ngayKyQD: ngayKyQD,
                soQD: values.soQD,
                idsTaiLieuQDBLXoa: idsTaiLieuQDBLXoa
            }

            await luuQuyetDinhBacLuong(request);
            setShowModalLuong(false);
            toast.success('Lưu bậc lương thành công!')
        }
        catch (err: any) {
            setShowModalLuong(false);
            toast.error('Đã xảy ra lỗi, lưu không thành công!');
        }

        setLoading(false);
        onSubmit();
    };

    const setFormDetailModal = (value: BacLuongResponse | null) => {
        form.setFieldsValue({
            idHopDong: idHopDong,
            id: value?.idQuyetDinhBacLuong,
            idChucVu: value?.idChucVu,
            idHeSoLuong: value?.idHeSoLuong,
            idDonVi: value?.idDonVi,
            soQD: value?.soQD,
            mucLuongThucNhan: value?.mucLuongThucNhan || 0,
            idNhomNhanSu: value?.idNhomNhanSu || null,
            mucLuongThucNhanStr: value?.mucLuongThucNhan ? currencyFormat.formatMoney(value?.mucLuongThucNhan) : "",
            ngayKyQD: value?.ngayKyQD ? dayjs(dateCommon.formatDate(value?.ngayKyQD), "DD/MM/YYYY") : undefined,
            ngayBatDau: value?.ngayBatDau ? dayjs(dateCommon.formatDate(value?.ngayBatDau), "DD/MM/YYYY") : undefined,
            ngayKetThuc: value?.ngayKetThuc ? dayjs(dateCommon.formatDate(value?.ngayKetThuc), "DD/MM/YYYY") : undefined
        });

        value?.idChucVu && loadDataHeSoLuong(value?.idChucVu);
        setShowModalLuong(true);
    }

    const xoaQDBL = async () => {
        try {
            setLoading(true);
            await xoaQuyetDinhBacLuong(idXoaQDBL);
            toast.success('Xoá quyết định bậc lương thành công!');
        }
        catch (err: any) {
            toast.error('Đã xảy ra lỗi, xoá không thành công!');
        }
        setIdXoaQDBL(0);
        setLoading(false);
        onSubmit();
    }

    useEffect(() => {
        loadDataSelectBoxs();
    }, [])

    useEffect(() => {   
        setBacLuongSelected(defaultSelect);
        var fileHienTaiEffect: any = (defaultSelect?.dsTaiLieu || []).map((item: TaiLieu) => {
            return {
                uid: item.idTaiLieu + "tailieu",
                name: item.tenTep,
                status: 'done',
                url: urlAdmin + item.duongDan.replace(/\\/g, "/"),
                //url: item.duongDan.replace("View\\public", urlAdmin).replace(/\\/g, "/"),
            };
        });
        setFileList(fileHienTaiEffect);
    }, [defaultSelect])

    return (
        <div className="card-outline">
            {showModalLuong && <ModalTextForm title="Quản lý bậc lương"
                hideFooter
                show={showModalLuong}
                handleClose={() => setShowModalLuong(false)}
            >
                <Form
                    layout="vertical"
                    validateMessages={validateMessages}
                    onFinish={onFinish}
                    form={form}
                >
                    <Form.Item hidden name="id"><Input /></Form.Item>
                    <Form.Item hidden name="idHopDong"><Input /></Form.Item>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Phòng ban"
                                name="idDonVi"
                                rules={[
                                    {
                                        required: true
                                    }
                                ]}

                            >
                                <DonViSelectTree name="idDonVi" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Chức vụ"
                                name="idChucVu"
                                rules={[
                                    {
                                        required: true
                                    }
                                ]}
                            >
                                <Select notFoundContent={<div>Không có dữ liệu</div>} options={optionChucVu} onChange={(e) => loadDataHeSoLuong(e)} loading={loading} placeholder="Chọn chức vụ" />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Số quyết định"
                                name="soQD"
                                rules={[
                                    {
                                        required: true
                                    },
                                    {
                                        max: 20
                                    }
                                ]}
                            >
                                <Input
                                    placeholder="Số quyết định"
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Ngày quyết định"
                                name="ngayKyQD"
                            >
                                <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="Ngày nhận quyết định" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Ngày bắt đầu"
                                name="ngayBatDau"
                                rules={[{ required: true }]}
                            >
                                <DatePicker changeOnBlur={true} disabledDate={(current: any) => {
                                    const ngayKetThuc = form.getFieldsValue(['ngayKetThuc']);                                    
                                    return current && current > ngayKetThuc?.ngayKetThuc;
                                }} style={{ width: "100%" }} placeholder="Ngày bắt đầu" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Ngày kết thúc"
                                name="ngayKetThuc"
                            >
                                <DatePicker
                                    changeOnBlur={true}
                                    disabledDate={(current: any) => {                                        
                                        const ngayBatDau = form.getFieldsValue(['ngayBatDau']);                                                                                
                                        return current && current < ngayBatDau?.ngayBatDau;
                                    }} style={{ width: "100%" }} placeholder="Ngày kết thúc" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Bậc lương"
                                name="idHeSoLuong"
                                rules={[
                                    {
                                        required: true,
                                    }
                                ]}
                            >
                                <Select notFoundContent="Không có dữ liệu" options={optionHeSoLuong} loading={loading} placeholder="Chọn hệ số lương" onChange={onChangeHeSoLuong} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Mức lương thực nhận"
                                name="mucLuongThucNhanStr"
                                rules={[
                                    {
                                        required: true,
                                    }
                                ]}
                            >
                                <Input prefix="₫ " 
                                    onChange={handleChangeCurrency}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Nhóm nhân sự"
                                name="idNhomNhanSu"
                                rules={[
                                    {
                                        required: true,
                                    }
                                ]}
                            >
                                <NhomNhanSuSelectBox onChange={() => { }} />
                            </Form.Item>
                        </Col>                        
                    </Row>
                    <Form.Item hidden name="mucLuongThucNhan" >
                        <Input />
                    </Form.Item>
                    <Row>
                        <Col span="24">
                            <Upload {...props}>
                                <Button icon={<UploadOutlined rev="" />}>Thêm file</Button>
                            </Upload>
                        </Col>
                    </Row>
                    <Form.Item>
                        <Button type="primary" className="float-right" htmlType="submit" loading={loading} icon=<SaveOutlined rev="" />>
                            Lưu
                        </Button>
                    </Form.Item>
                </Form>
            </ModalTextForm>}
            {idXoaQDBL > 0 && <ModalTextForm show={idXoaQDBL > 0}
                title="Xoá quyết định bậc lương"
                handleClose={() => setIdXoaQDBL(0)}
                handleSave={() => xoaQDBL()}>
                Xác nhận xoá quyết định bậc lương đang chọn
            </ModalTextForm>}
            <Tabs tabBarExtraContent=
                {isThemMoi &&
                    <Button
                        onClick={() => {
                            setFormDetailModal(null);
                        }}
                        icon={<PlusOutlined rev="" />}
                        className="hrm-btn hrm-btn-warning"
                    >
                        Thêm mới
                    </Button>}
                defaultActiveKey="1" items={[
                {
                    key: '1',
                    label: 'Quyết định bậc lương',
                    children:
                        <div className="card">
                            <Table
                                locale={{ emptyText: "Không có dữ liệu" }}
                                dataSource={(listData || []).map((value, index) => { const item = { key: index, ...value }; return item; })}
                                pagination={false}
                                onRow = {(record, rowIndex) => {
                                    if (select) {
                                        return {
                                            onClick: event => {
                                                if (onRowSelected != null) {
                                                    onRowSelected(record);
                                                }
                                            },
                                        };
                                    }
                                    return {};
                                }}
                                rowClassName={(record, index) => {
                                    return (select && ((record?.idQuyetDinhBacLuong === bacLuongSelected?.idQuyetDinhBacLuong))) ? "selected-row row-key-" : "";
                                }}>
                                <Column
                                    width="60px"
                                    title="STT"
                                    key="STT"
                                    align="center"
                                    render={(value, record, index) =>
                                    (
                                        <>
                                            {index + 1}
                                        </>
                                    )
                                    }
                                />

                                <Column width="15%" title="Số QĐ" key="soQD" dataIndex="soQD" />
                                <Column width="8%" title="Ngày ký" key="ngayKyQD" render={(value, record, index) =>
                                (
                                    <>
                                        {dateCommon.formatDate(value?.ngayKyQD)}
                                    </>
                                )
                                } />
                                <Column width="9%" title="Ngày bắt đầu" key="ngayBatDau" render={(value, record, index) =>
                                (
                                    <>
                                        {dateCommon.formatDate(value?.ngayBatDau)}
                                    </>
                                )
                                } />
                                <Column width="9%" title="Ngày kết thúc" key="ngayKetThuc" render={(value, record, index) =>
                                (
                                    <>
                                        {dateCommon.formatDate(value?.ngayKetThuc)}
                                    </>
                                )
                                } />
                                <Column width="16%" title="Phòng ban" key="tenDonVi" dataIndex="tenDonVi" />
                                <Column width="9%" title="Chức vụ" key="tenChucVu" dataIndex="tenChucVu" />
                                <Column width="7%" title="Hệ số" key="heSo" dataIndex="heSo" />
                                <Column width="10%" title="Mức lương" key="mucLuong"
                                    render={(value, record, index) =>
                                    (
                                        <>
                                            {formatVND(value?.mucLuong)}
                                        </>
                                    )
                                    }
                                />
                                {
                                    isThemMoi &&
                                    <Column width="10%" title="" key="action"
                                        render={(value, record, index) =>
                                        (
                                            <Space>
                                                <Button type="primary" size={"small"} loading={loading} title="Sửa"
                                                    icon=<EditOutlined rev="" />
                                                    onClick={() => { setFormDetailModal(value); }}
                                                >
                                                    Sửa
                                                </Button>
                                                <Button type="primary" danger size={"small"} loading={loading} title="Xóa"
                                                    onClick={() => setIdXoaQDBL(value.idQuyetDinhBacLuong)}
                                                    icon=<DeleteOutlined rev="" />
                                                >
                                                    Xóa
                                                </Button>
                                            </Space>
                                        )
                                        }
                                    />
                                }
                            </Table>
                        </div>
                },
            ]}>
            </Tabs>
        </div>
    );
};

export default QuyetDinhBatLuongBox;
